export const environment = {
  captureService: '/rocketcapture/api/public/v1/form-data',
  documentService: '/document/api/portal/v1',
  linxV2Endpoint: '/rocketcapture/api/public/v2/workflows',
  linxLinksEndpoint: '/rocketcapture/api/public/v2/links',
  documentAcceptanceService: '/acceptances',
};
